<script type="ts">
	export let channels: string[] = [];
	export let active: string = 'devchat';
</script>

{#each channels as channel}
	<div class="channel" on:click={() => active = channel} class:active={channel === active}>
		<div class="pwn">#</div>
		{channel}
	</div>
{/each}

<style lang="scss">
	.channel {
		display: flex;
		align-items: center;
		padding: 0px 14px;
		font-weight: 600;
		cursor: pointer;
		color: var(--demo-text-low);
		border-radius: $border_radius;
		margin-bottom: 2px;
		&:hover {
			background-color: var(--demo-overlay);
			color: var(--demo-text);
		}
	}

	.active {
		background-color: var(--demo-overlay);
		color: var(--demo-text);
	}

	.pwn {
		font-size: 1.5em;
		margin-right: 7px;
		color: var(--demo-bg-60);
		font-weight: 300;
	}
</style>
